<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <blockquote style="margin:0 0 0 40px;border:none;padding:0px;">
        <p v-html="text.profile6"></p>
      </blockquote>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: {
        profile6:
          "<br />China Material, founded in 2003 in Beijing of China, is a global company who specializes in metals, minerals, carbons, pharmaceutical raw materials and complete plants. As a leading Chinese supplier of the kinds of material, China Material International has been cooperating with many top companies worldwide in the different fields."
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus' scoped>
</style>


// WEBPACK FOOTER //
// src/components/en/profile/gsjj.vue